import { createStore, combineReducers, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import auth from './Auth/ActionAuth';
import { authorizeReducer } from './Auth/ReducerAuth';

const reducer = combineReducers({ auth, authorizeReducer });
const middleware = composeWithDevTools(
  applyMiddleware(thunkMiddleware, createLogger({ collapsed: true }))
);
const store = createStore(reducer, middleware);

export default store;
export * from './Auth/ActionAuth';
export * from './Auth/ReducerAuth';
